<template>
  <div class="layout-container">
    <sidebar>
      <div class="sidebar-section-top">
        <img class="logo" :src="`/assets/logo-white.png`">

        <div class="department">{{ $t('Department') }}:</div>
        <v-menu v-if="groups.length > 1" bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              dark
              v-bind="attrs"
              v-on="on"
              text
              style="font-size: 16px; width: 100%;"
            >
              {{ $store.state.selectedGroup }}
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(group, index) in groups"
              :key="index"
            >
              <v-btn
                text
                @click="changeGroup(group.name)"
                style="width: 100%"
              >{{ group.name }}</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <div
          v-if="groups.length <= 1"
          class="text-center pa-2"
          style="font-size: 16px;"
        >{{ $store.state.selectedGroup }}</div>
        <v-btn
          v-if="notificationsPermissions"
          :to="{ name: 'group-notifications' }"
          color="white"
          secondary
          style="margin-top: 24px; width: 100%"
        >{{ $t('Notifications') }}</v-btn>
      </div>

      <div class="sidebar-section-bottom">
        <div class="user-box">
          <div class="user-box-worker">{{ fullName }}</div>
        </div>

        <div @click="logout" class="logout-button">{{ $t('Log out') }}</div>
      </div>
    </sidebar>

    <div class="content">
      <transition name="slide" mode="out-in" appear>
        <router-view :key="this.$route.params.groupName">

        </router-view>
      </transition>
    </div>
  </div>
</template>

<script>

import Sidebar from '@/globals/components/Sidebar.vue';
import { getBasicAuthLogoutUrl } from '@/globals/helpers/basicAuthLookup';

export default {
  name: 'Layout-overview',
  components: {
    Sidebar,
  },
  data() {
    return {
      selectedUserGroupIndex: 0,
    };
  },
  computed: {
    fullName() {
      return this.$store.state.authentication.user.fullName
        ? this.$store.state.authentication.user.fullName
        : this.$store.state.authentication.user.username;
    },
    groups() {
      return this.$store.state.authentication.user.groups;
    },
    notificationsPermissions() {
      return this.$p.hasAll('notifications');
    },
  },
  methods: {
    changeGroup(name) {
      this.$store.dispatch('entities/deleteAll');
      this.$router.push({ name: this.$route.name, params: { groupName: name } });
    },
    selectUserGroup(index) {
      this.selectedUserGroupIndex = index;
    },
    async logout() {
      const basicAuthLogoutUrl = getBasicAuthLogoutUrl(
        this.$store.state.authentication.user?.email,
      );
      if (basicAuthLogoutUrl) {
        const logoutWindow = window.open(basicAuthLogoutUrl, 'Logout', 'menubar=0,resizable=1,width=10,height=10');
        await new Promise((resolve) => {
          setTimeout(() => {
            logoutWindow.close();
            resolve();
          }, 2000);
        });
      }

      this.$store.dispatch('authentication/logout');
    },
  },
};

</script>

<style scoped lang="scss">
  .layout-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
  }

  .sidebar {

    .logo {
      font-size: 26px;
      margin-bottom: 50px;
      width: 80%;
    }

    .department {
      font-size: 14px;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.8);
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      margin-bottom: 4px;
    }

    .department-name {
      font-size: 26px;
      font-weight: 100;
      margin-bottom: 100px !important;
      color: #fff;
      text-decoration: none;
      display: block;
    }

    .member-groups {
      padding-left: 12px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .member-groups-item {
      display: inline;
      padding: 12px 12px;
      border-bottom: 1px solid transparent;
      cursor: pointer;
      transition: all 0.2s;
      border-radius: 2px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);

      }
    }

    .selected-user-groups-item {
      border-bottom: 1px solid #fff;
    }

    .sidebar-section-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .user-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      margin-bottom: 60px;

      &-worker {
        font-weight: bold;
        font-size: 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
        word-break: break-all;
      }

      &-name {
        font-size: 22px;
        margin-bottom: 4px;
      }

      &-profession {
        font-size: 16px;
      }
    }

    .logout-button {
      border: 1px solid #fff;
      border-radius: 8px;
      padding: 10px 42px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    max-height: 100vh;
    overflow: auto;
  }
</style>
